import { render, staticRenderFns } from "./CadastroLoteDetalhes.vue?vue&type=template&id=3002230e&scoped=true&lang=pug"
import script from "./CadastroLoteDetalhes.vue?vue&type=script&lang=js"
export * from "./CadastroLoteDetalhes.vue?vue&type=script&lang=js"
import style0 from "./CadastroLoteDetalhes.vue?vue&type=style&index=0&id=3002230e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3002230e",
  null
  
)

export default component.exports